module.exports = __webpack_public_path__ + "img/pub-messenger-new-message-blink.462cdf4e.svg";